module.exports = __webpack_public_path__ + "static/media/illustration-page-error.3006e85d.png";